<template>
    <div class="box-wrap active-box-wrap" :style="boxWrapStyleObj">
        <span class="border-left-top"></span>
        <span class="border-left-bottom"></span>
        <span class="border-right-top"></span>
        <span class="border-right-bottom"></span>
        <div
                class="statis-title bg1"
                style="display: flex; justify-content: center; margin-bottom: 10px;"
                :ref="`${activeType}_statisTitle`"
        >
            <span class="ability-title"
                  :class="titleType=='subject'?'ability-title-select':''"
                  @click="changeTitleType('subject')"
            >学科能力</span>
            <span class="split-line">|</span>
            <span class="ability-title"
                  :class="titleType=='knowledge'?'ability-title-select':''"
                  @click="changeTitleType('knowledge')"
            >知识掌握</span>
            <span class="active-box-more-txt click-element" @click="lookMoreData">
                更多
                <i></i>
            </span>
        </div>
        <!--学科和年级筛选-->
        <div class="cloud-active-static-tab-content-total-sel-box">
            <el-select v-model="subjectId" placeholder="全部学科" @change="changeSubject">
                <el-option value="ENGLISH" label="英语"></el-option>
                <el-option value="MATH" label="数学"></el-option>
                <el-option value="CHINESE" v-if="titleType=='subject'" label="语文"></el-option>
            </el-select>

            <el-select v-model="gradeId" placeholder="全部年级" @change="changeGrade">
                <el-option
                        v-for="item in gradeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </div>
        <!--雷达图-->
        <div :style="{ height: contentStyleObj.height }" v-if="titleType=='subject'"
             class="cloud-active-static-chart-content">
            <Spin fix v-if="isLoading">
                <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
                <div class="spin-text">加载中</div>
            </Spin>
            <template v-else>
                <div id="subject-ability" v-show="!isShow"
                     :style="{ height: contentStyleObj.height,width: contentStyleObj.width }"></div>
                <div style="padding-top: 100px;" v-show="isShow">
                    暂无数据
                </div>
            </template>
        </div>
        <div :style="{ height: contentStyleObj.height }" class="cloud-active-static-chart-content" v-else>
            <Spin fix v-if="isLoading">
                <Icon type="ios-loading" size=30 class="demo-spin-icon-load"></Icon>
                <div class="spin-text">加载中</div>
            </Spin>
            <template v-else>
                <div id="knowledge-ability" v-show="!isShow"
                     :style="{ height: contentStyleObj.height,width: contentStyleObj.width }" style='width:100%'></div>
                <div style="padding-top: 100px;" v-show="isShow">
                    暂无数据
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import {fetchKnowledgeMasterData, fetchSubjectAbilityData} from "../../../service/bigDataApi.js";

    export default {
        name: "subject-knowledge-ability",
        data() {
            return {
                screenWidth: 0, //屏幕宽度
                boxWrapStyleObj: {
                    height: "",
                },
                contentStyleObj: {
                    width: '',
                    height: "",
                },
                styleObj: {
                    width: "100%",
                    height: "100%",
                },
                timeSolt: "1",
                startDate: "",
                endDate: "",
                title: "教师活跃情况",
                activeType: "teacher",
                isShow: false,
                titleType: 'subject',
                //年级id
                gradeId: '6',
                //学科id
                subjectId: 'ENGLISH',
                // 年级集合
                gradeList: [
                    {
                        name: '六年级',
                        id: '6'
                    },
                    {
                        name: '五年级',
                        id: '5'
                    },
                    {
                        name: '四年级',
                        id: '4'
                    },
                    {
                        name: '三年级',
                        id: '3'
                    },
                    {
                        name: '二年级',
                        id: '2'
                    },
                    {
                        name: '一年级',
                        id: '1'
                    },
                ],
                // 学科集合
                subjectList: [
                    {
                        name: '英语',
                        id: 'ENGLISH'
                    },
                    {
                        name: '数学',
                        id: 'MATH'
                    },
                    {
                        name: '语文',
                        id: 'CHINESE'
                    }
                ],
                //数据是否正在加载中
                isLoading: true,
                //学科能力集合
                subjectAbilityList: [],
                //知识掌握能力集合
                knowledgeAbilityList: []
            };
        },
        props: {
            screenHeight: Number,
            titleHeight: Number,
            schoolId: String,
            schoolName: String,
            schoolCode: String,
        },
        watch: {
            screenHeight: "initBoxHeight",
            titleHeight: "initBoxHeight",
        },
        methods: {
            /**
             * 初始化box高度
             */
            initBoxHeight() {
                let titleRef = this.activeType + "_statisTitle";
                let winHeight = window.innerHeight;
                let winWidth = window.innerWidth * 0.25 - 30;
                if (winHeight < 900) {
                    winHeight = 938;
                }
                let boxWrapHeight = (winHeight - 128 - 10 - 30) / 3;
                let contentHeight =
                    boxWrapHeight - this.$refs[titleRef].offsetHeight - 20;
                this.boxWrapStyleObj.height = boxWrapHeight + "px";
                this.contentStyleObj.height = contentHeight + "px";
                this.contentStyleObj.width = winWidth + "px";
            },
            /**
             * 切换标题类型
             */
            changeTitleType(type) {
                this.titleType = type;
                this.isLoading = true;
                if (this.titleType == 'subject') {
                    this.getSubjectAbilityData()
                } else {
                    this.subjectId = this.subjectId == 'CHINESE' ? 'ENGLISH' : this.subjectId;
                    this.getKnowledgeMasterData()
                }
            },
            /**
             * 获取学科能力数据
             */
            async getSubjectAbilityData() {
                let _this = this;
                let param = {
                    schoolId: _this.schoolId,
                    grade: _this.gradeId
                };
                await fetchSubjectAbilityData(param)
                    .then(function (data) {
                        //数据加载完成
                        _this.isLoading = false;
                        _this.subjectAbilityList = data;
                        _this.setAreaBgColorByName(_this.subjectAbilityList);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取知识掌握能力数据
             */
            async getKnowledgeMasterData() {
                let _this = this;
                let param = {
                    schoolId: _this.schoolId,
                    grade: _this.gradeId
                };
                await fetchKnowledgeMasterData(param)
                    .then(function (data) {
                        //数据加载完成
                        _this.isLoading = false;
                        _this.knowledgeAbilityList = data;
                        _this.setAreaBgColorByName(_this.knowledgeAbilityList);
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 根据数据设置雷达图区域背景色图片
             */
            setAreaBgColorByName(data) {
                let _this = this;
                for (let i = 0; i < data.length; i++) {
                    if (data[i].legendData && data[i].legendData.length > 0) {
                        for (let j = 0; j < data[i].legendData.length; j++) {
                            let value = [];
                            data[i].legendData[j].data.forEach((item) => {
                                value.push(item * 100);
                            });
                            data[i].legendData[j].value = value;
                            if (data[i].legendData[j].name == '全国') {
                                data[i].legendData[j].areaStyle = {
                                    normal: {
                                        opacity: 0.2,
                                        color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#1fffe2"},
                                            {offset: 0.4, color: "#1fffe2"},
                                            {offset: 1, color: "#1fffe2"},
                                        ]),
                                    }
                                };
                                data[i].legendData[j].lineStyle = {
                                    color: "#12ACC5", //图表中各个图区域的边框线颜色
                                    width: 1
                                }
                            } else if (data[i].legendData[j].name == '白云区') {
                                data[i].legendData[j].areaStyle = {
                                    normal: {
                                        opacity: 0.4,
                                        color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#c4596d"},
                                            {offset: 0.4, color: "#c4596d"},
                                            {offset: 1, color: "#c4596d"},
                                        ]),
                                    }
                                };
                                data[i].legendData[j].lineStyle = {
                                    color: "#c4596d",//图表中各个图区域的边框线颜色
                                    width: 1
                                }
                            } else {
                                data[i].legendData[j].areaStyle = {
                                    normal: {
                                        opacity: 0.2,
                                        color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                            {offset: 0, color: "#ffff58"},
                                            {offset: 0.4, color: "#93ff98"},
                                            {offset: 1, color: "#93ff98"},
                                        ]),
                                    }
                                };
                                data[i].legendData[j].lineStyle = {
                                    color: '#ffe47d',
                                    width: 1
                                }
                            }
                        }
                    }
                }
                let resultData = data;
                //根据学科获取学科能力
                let abilityList = _this.getAbilityData(resultData);
                _this.$nextTick(() => {
                    _this.initDataSource(abilityList);
                });
            },
            /**
             * 切换学科
             */
            changeSubject() {
                let abilityList = [];
                if (this.titleType == 'subject') {
                    abilityList = this.getAbilityData(this.subjectAbilityList);
                } else {
                    abilityList = this.getAbilityData(this.knowledgeAbilityList);
                }
                this.$nextTick(() => {
                    this.initDataSource(abilityList);
                });
            },
            /**
             * 切换年级
             */
            changeGrade() {
                this.isLoading = true;
                if (this.titleType == 'subject') {
                    this.getSubjectAbilityData()
                } else {
                    this.getKnowledgeMasterData()
                }
            },
            /**
             * 获取能力
             */
            getAbilityData(data) {
                let abilityList = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].subject == this.subjectId) {
                        abilityList = data[i];
                    }
                }
                return abilityList;
            },
            /**
             * 初始化折线图
             */
            initDataSource(abilityList) {
                let _this = this;
                let id = _this.titleType == 'subject' ? 'subject-ability' : 'knowledge-ability';
                let data = _this.titleType == 'subject' ? ['#0EFCFF', '#C4596D', '#FFE47D'] : ['#C4596D', '#FFE47D'];
                let dataSource = _this.$echarts.init(
                    document.getElementById(id)
                );
                _this.isShow = !(abilityList.legendData && abilityList.legendData.length > 0);
                let radiusVal = 65;
                let fontSize = 12;
                let tooltipFontSize = 14;
                if (this.screenWidth <= 1536) {
                    radiusVal = 40;
                }
                const option = {
                    color: data,
                    legend: {
                        itemWidth: 6,
                        itemHeight: 6,
                        icon: "circle",
                        textStyle: {
                            color: '#A1B6EB'
                        },
                        right: 0,
                        bottom: '0',
                        orient: 'vertical',
                        data: ['全国', '白云区', '白云区第十五小']
                    },
                    tooltip: {
                        show: false,
                        trigger: 'axis'
                    },
                    grid: {
                        top: "0",
                        bottom: "0"
                    },
                    radar: [
                        {
                            indicator: abilityList.indicatorData,
                            center: ['40%', '48%'],
                            radius: radiusVal,
                            name: {
                                formatter: '{value}',
                                textStyle: {
                                    color: '#A1B6EB',
                                    fontSize: fontSize
                                }
                            },
                            axisLine: {
                                lineStyle: {
                                    width: 1,
                                    color: '#F9FBFB',
                                    opacity: 0.2
                                }
                            },
                            splitArea: {
                                //设置渐变背景色
                                areaStyle: {
                                    color: ['rgba(14,252,255,0.4)',
                                        'rgba(14,252,255,0.3)',
                                        'rgba(14,252,255,0.2)',
                                        'rgba(14,252,255,0.2)',
                                        'rgba(14,252,255,0.1)'],
                                    shadowColor: 'rgba(0,0,0,0.3)',
                                    shadowBlur: 10
                                }
                            },
                            splitLine: {
                                show: false,
                                lineStyle: {
                                    width: 1,
                                    color: '#0EFCFF',
                                    opacity: 0.45
                                }
                            }
                        }
                    ],

                    series: [{
                        type: 'radar',
                        tooltip: {
                            trigger: 'item',
                            position: ['0%', '0%'],
                            textStyle: {
                                fontSize: tooltipFontSize
                            }
                        },
                        itemStyle: {
                            normal: {
                                areaStyle: {
                                    color: {
                                        type: 'linear',
                                        x: 0,
                                        y: 0,
                                        x2: 0,
                                        y2: 1,
                                        colorStops: [{
                                            offset: 0, color: '#0EFCFF'
                                        }, {
                                            offset: 1, color: '#2783CD'
                                        }],
                                        globalCoord: false
                                    },
                                    borderColor: '#000',
                                    opacity: 0.85
                                },
                                lineStyle: {
                                    color: '#2675B9'
                                }
                            }
                        },
                        data: abilityList.legendData
                    }]
                };
                dataSource.setOption(option);
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            },
            /**
             * 查看更多数据信息
             */
            lookMoreData() {
                let href = 'https://www.17zuoye.com/redirector/login/dc8207ece3b5496a5d62796b443cab199326f6bc5b70896beb7d24d5d6cb3083264b91339860c67027d22ac932b4779a.vpage\n'
                window.open(href, "_blank");
            }
            ,
        },
        mounted() {
            //获取学科能力数据
            this.getSubjectAbilityData();
            //获取屏幕宽度
            this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        }
        ,
    }
    ;
</script>

<style lang="scss" scoped>
    @import "../../../style/databoard";
    @import "../../../style/layout";

    .bg1 {
        background-image: url("../../../assets/images/databoard/title-bg3.png");
    }

    .ability-title {
        cursor: pointer;
        font-weight: 500 !important;
        font-size: 14px !important;
    }

    .ability-title-select {
        font-weight: bolder !important;
        font-size: 16px !important;
    }

    .active-box-more-txt i {
        background-image: url(../../../assets/images/databoard/active-icon.png);
        background-position: -299px 90px;
    }

    .active-static-icon-arrow-down {
        background-image: url(../../../assets/images/databoard/active-icon.png);
        background-position: -224px 90px;
    }
</style>

<style lang="scss">
    .cloud-active-static-tab-content-total-sel-box {
        display: flex;
        position: absolute;
        right: 0;
        z-index: 9999;
        .ivu-select {
            padding-right: 5px;
            text-align: center;
            color: #0efcff !important;
        }

        .el-input__inner {
            height: 26px !important;
            background: rgba(14, 252, 255, 0.05) !important;
            box-shadow: inset 0 0 10px 4px rgba(14, 252, 255, 0.15) !important;
            border: unset !important;
            color: #0efcff !important;
        }
        .el-input__icon {
            color: #0efcff !important;
            line-height: 26px !important;
        }

        /*.ivu-select-selection {*/
        /*height: 26px !important;*/
        /*background: rgba(14, 252, 255, 0.05) !important;*/
        /*box-shadow: inset 0 0 10px 4px rgba(14, 252, 255, 0.15) !important;*/
        /*border: unset !important;*/
        /*}*/
        /*.ivu-select-single .ivu-select-selection .ivu-select-placeholder {*/
        /*color: #0efcff !important;*/
        /*}*/

        /*.ivu-select-arrow {*/
        /*color: #0efcff !important;*/
        /*}*/

        /*.ivu-select-single .ivu-select-selection .ivu-select-placeholder, .ivu-select-single .ivu-select-selection .ivu-select-selected-value {*/
        /*height: 26px !important;*/
        /*line-height: 26px !important;*/
        /*}*/

        /*.ivu-select-dropdown {*/
        /*max-height: 95px;*/
        /*background: rgba(10, 18, 39, 0.97);*/
        /*box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;*/
        /*border-radius: 5px*/
        /*}*/
        /*.ivu-select-item {*/
        /*color: #0efcff !important;*/
        /*}*/

        /*.ivu-select-item:hover {*/
        /*background: #0efcff !important;*/
        /*color: #0a1227 !important;*/
        /*}*/

        /*.ivu-select-item-focus {*/
        /*background: #0efcff !important;*/
        /*color: #0a1227 !important;*/
        /*}*/
    }

    .cloud-active-static-chart-content {
        .ivu-spin-fix {
            background: transparent !important;
            width: 100px;
            height: 100px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
        .demo-spin-icon-load {
            animation: ani-demo-spin 1s linear infinite;
        }
        .spin-text {
            font-size: 16px;
            margin-top: 10px;
        }
    }

    .el-select {
        width: 100px !important;
        margin-right: 5px;
    }

    .el-select-dropdown {
        background: rgba(10, 18, 39, 0.97);
        box-shadow: inset 0px 0px 10px 4px rgba(14, 252, 255, 0.15) !important;
        border-radius: 5px;
        border: 0 !important
    }

    .popper__arrow {
        display: none !important;
    }

    .el-select-dropdown__item {
        color: #0efcff !important;
    }

    .el-select-dropdown__item.selected {
        background: #0efcff !important;
        color: #0a1227 !important;
    }

    .el-select-dropdown__item.hover {
        background: #0efcff !important;
        color: #0a1227 !important;
    }
</style>
